import React, { createContext, useContext, useState } from "react";

const GenderPopupContext = createContext({ open: false, setOpen: () => {} });

export const GenderPopupProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <GenderPopupContext.Provider value={{ open, setOpen }}>
      {children}
    </GenderPopupContext.Provider>
  );
};

export const useGenderPopup = () => useContext(GenderPopupContext);
